import React, { useState } from 'react';
import { 
  FaBell, 
  FaUserCircle, 
  FaSignOutAlt, 
  FaSearch, 
  FaGlobe,
  FaTimes
} from 'react-icons/fa';

const DashboardTopbar = ({ currentUser, role, onLogout, sidebarCollapsed }) => {
  const [showNotifications, setShowNotifications] = useState(false);

  // Note: Theme toggle functionality has been permanently removed to enforce the white theme.


  const mockNotifications = [
    { id: 1, title: 'New Registration Request', desc: 'Sarah Jenkins registered as Patient', time: '5m ago', type: 'info' },
    { id: 2, title: 'Appointment Rescheduled', desc: 'Dr. Albert set slot at 3:00 PM', time: '1h ago', type: 'warning' },
    { id: 3, title: 'Urgent Contact Submission', desc: 'Message regarding physical therapy inquiry', time: '3h ago', type: 'danger' },
  ];

  return (
    <header className={`fixed top-0 right-0 h-16 bg-white  border-b border-slate-200  z-20 flex items-center justify-between px-6 transition-all duration-300 ${
      sidebarCollapsed ? 'left-20' : 'left-20 sm:left-64'
    }`}>
      {/* Search Input Bar */}
      <div className="relative w-48 sm:w-80">
        <input
          type="text"
          placeholder="Search patients, rosters, files... (Ctrl + K)"
          className="w-full bg-slate-50  border border-slate-200  rounded-lg py-1.5 pl-9 pr-4 text-xs focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all text-slate-800 "
          onClick={() => alert("Search Command Palette shortcut activated! Search mock indexes for: 'Appointments', 'Staff', 'Registration'.")}
        />
        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400  text-xs" />
      </div>

      {/* Control rack */}
      <div className="flex items-center gap-4">
        {/* Global locale */}
        <div className="flex items-center text-slate-400  hover:text-purple-600 :text-purple-400 cursor-pointer p-2 rounded-lg hover:bg-slate-50 :bg-slate-900">
          <FaGlobe size={15} />
          <span className="text-xs font-semibold ml-1.5 hidden md:inline">EN</span>
        </div>

        {/* Notification Bell */}
        <div className="relative">
          <button 
            onClick={() => setShowNotifications(!showNotifications)}
            className="p-2 text-slate-400  hover:text-purple-600 :text-purple-400 rounded-lg hover:bg-slate-50 :bg-slate-900 transition-colors relative"
            title="View notification feed"
          >
            <FaBell size={15} />
            <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-rose-500"></span>
          </button>

          {/* Drawer Dropdown */}
          {showNotifications && (
            <div className="absolute right-0 mt-2 w-80 bg-white  border border-slate-200  shadow-xl rounded-xl py-2 z-50">
              <div className="flex items-center justify-between px-4 py-2 border-b border-slate-300 ">
                <span className="font-bold text-sm text-slate-800 ">Clinic Alerts</span>
                <button onClick={() => setShowNotifications(false)} className="text-slate-400  hover:text-rose-500"><FaTimes size={12} /></button>
              </div>
              <div className="divide-y divide-slate-100  max-h-64 overflow-y-auto">
                {mockNotifications.map(n => (
                  <div key={n.id} className="p-3 hover:bg-slate-50 :bg-slate-900/50 transition-colors cursor-pointer text-xs">
                    <div className="flex justify-between font-semibold text-slate-800  mb-0.5">
                      <span>{n.title}</span>
                      <span className="text-slate-400  font-normal text-xxs">{n.time}</span>
                    </div>
                    <p className="text-slate-600 ">{n.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Vertical divider */}
        <span className="h-6 w-px bg-slate-200 "></span>

        {/* User Card Profile details */}
        {currentUser && (
          <div className="flex items-center gap-3">
            {currentUser.avatarUrl ? (
              <img src={currentUser.avatarUrl} alt="avatar" className="w-8 h-8 rounded-full border border-slate-200  object-cover" />
            ) : (
              <FaUserCircle className="text-slate-400  text-2xl" />
            )}
            <div className="hidden lg:flex flex-col text-left">
              <span className="font-semibold text-xs text-slate-800  truncate max-w-[150px]" title={currentUser.email}>{currentUser.email}</span>
              <span className="capitalize text-xxs font-bold text-purple-600  tracking-wide">{role}</span>
            </div>

            {/* Logout button */}
            <button 
              onClick={onLogout}
              className="p-2 text-slate-400  hover:text-rose-600 :text-rose-400 hover:bg-rose-50 :bg-rose-950/30 rounded-lg transition-colors"
              title="Log out of session"
            >
              <FaSignOutAlt size={15} />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default DashboardTopbar;
